import React, { useState } from "react";

import { Field } from "components/ui";
import SaveBar from "features/account/SaveBar";
import useSaveProfile from "features/account/useSaveProfile";

// "Password": the current password, then the new one twice. Other devices
// are signed out once it changes.
export default function PasswordForm() {
  const { errors, status, save, reset } = useSaveProfile();
  const [form, setForm] = useState({ current_password: "", password: "", confirm: "" });
  const [mismatch, setMismatch] = useState(null);

  const set = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setMismatch(null);
    reset();
  };

  async function submit(e) {
    e.preventDefault();
    if (form.password.length < 8) return setMismatch("Use at least 8 characters.");
    if (form.password !== form.confirm) return setMismatch("The two passwords don't match.");
    const saved = await save({ current_password: form.current_password, password: form.password });
    if (saved) setForm({ current_password: "", password: "", confirm: "" });
    return undefined;
  }

  return (
    <form onSubmit={submit} noValidate className="yc-account-form">
      <Field label="Current password" name="current_password" type="password" value={form.current_password} onChange={set} error={errors.current_password} autoComplete="current-password" />
      <Field label="New password" name="password" type="password" value={form.password} onChange={set} error={errors.password} hint="At least 8 characters." autoComplete="new-password" />
      <Field label="Confirm new password" name="confirm" type="password" value={form.confirm} onChange={set} error={mismatch} autoComplete="new-password" />
      <SaveBar status={status} error={errors.form} />
    </form>
  );
}
